//######################### Category Order #########################
export const ConfigKey_PertinentCategory_Order = 'pertinent-category-order';
//# sourceMappingURL=app-configs.js.map